import styled from '@mui/system/styled'
import { rgba } from 'polished'

import { statusChipBase } from 'components/Status/Status.styles'

import logError from 'utils/errorLogger'

import { theme } from 'styles/theme'

const getStatus = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        label: 'Pendente',
        background: rgba(theme.palette.neutral[700], 0.3),
        color: theme.palette.neutral[600]
      }
    case 'issued':
      return {
        label: 'Programada',
        background: rgba(theme.palette.alert[300], 0.3),
        color: theme.palette.alert[300]
      }
    case 'confirmed':
      return {
        label: 'Emitida',
        background: rgba(theme.palette.primary[300], 0.3),
        color: theme.palette.primary[300]
      }
    case 'canceled':
      return {
        label: 'Cancelada',
        background: rgba(theme.palette.error[300], 0.3),
        color: theme.palette.error[300]
      }
    case 'failed':
      return {
        label: 'Falhada',
        background: rgba(theme.palette.error[300], 0.3),
        color: theme.palette.error[300]
      }
    default:
      logError(`Erro ao mapear status da Nota fiscal: ${status} (getStatus)`)

      return {
        label: 'Status desconhecido',
        background: rgba(theme.palette.neutral[700], 0.3),
        color: theme.palette.neutral[600]
      }
  }
}

type StatusProps = {
  status: string
}

export const Status = styled('div')<StatusProps>(({ status }) => ({
  ...statusChipBase,
  ...getStatus(status)
}))
